<script>
    import { fly } from 'svelte/transition';
    import { isJson, object2array, postData } from '../scripts';
    import { permisos_title, permisos_struct, urlapi } from "../stores/store";

    export let permisos=$permisos_struct;
    export let acciones=true;

    let checkedAll=true;

    let cmd='botones' // botones | asignando | guardando
    let grupoTextGuardar=[];
    let grupoTextGuardarObj=null;
    let grupoTextGuardarError=false;
    let grupoTextGuardarMsj=false;
    let grupoTextDisabled=false;

    let assignPermisos=false;
    let assignPermisosDisabled=false;
    let assignValue=false;

    function selectAll(key,value) {
        let obj=permisos[key];
        obj=Object.keys(obj).reduce((acc, key) => {acc[key] = value; return acc; }, {})
        permisos[key]=obj;
    }
    function selectAllPerms(value) {
        Object.entries(permisos).forEach(element => selectAll(element[0],value) );
    }

   
    let save=function() {
      if(grupoTextGuardar.trim()=='') {
        grupoTextGuardarError='El nombre del grupo no puede estar vacio';
        grupoTextGuardarMsj=false;
        grupoTextGuardarObj.focus();
      } else {
        postData($urlapi, [{ 
            permisos,
            'nombre':grupoTextGuardar,
            'cmd':'users_guardarPermisos'
        }])
        .then(data => {
            grupoTextGuardarError=false;
            grupoTextDisabled=true
            grupoTextGuardarMsj=`el grupo <strong>${grupoTextGuardar}</strong> fue guardado`;
            setTimeout(() => { cmd='botones';grupoTextGuardarMsj=false; }, 2000);
        });         

      }
    }

    let guardar=function() {
      grupoTextGuardar='';
      grupoTextDisabled=false;
      grupoTextGuardarMsj=false;
      grupoTextGuardarError=false;
      cmd='guardar';
    }

    let asignar=function() {
      cmd='asignando';
      assignPermisos=[];
      assignPermisosDisabled=true;
      assignValue=0;
      postData($urlapi, [{ 
            'cmd':'users_listPermisos'
        }])
        .then(data => {
            assignPermisos=object2array(data[0].result);
            assignPermisosDisabled=false;
        });      
    }

    let asignGroup=function () {
      
      if(isJson( assignPermisos[assignValue].permisos )===true) {
          permisos=JSON.parse(assignPermisos[assignValue].permisos);
      }
      cmd='botones';
    }

</script>

<!-- svelte-ignore a11y-missing-attribute -->
<div class='mb-1'>
    <h6 class='fw-bold text-uppercase text-warning align-top d-inline-block'>Permisos</h6>
    <div class="form-check form-switch align-top d-inline-block" style='margin-top:-5px;'>
        <input class="form-check-input" type="checkbox" style='width:40px;height:20px;' on:change={(e) => { selectAllPerms(e.target.checked) }}>
    </div>

</div>
<div class="clearfix"></div>

<ul class="list-group">
    {#each $permisos_title as item,index}

    
            <li class="list-group-item list-group-item-primary" aria-current="true">
                <strong>{item.name}</strong>
                <div class="form-check form-switch float-end">
                    <input class="form-check-input" type="checkbox" style='width:40px;height:20px;' on:change={(e) => { selectAll(item.key,e.target.checked) }}>
                </div>                
            </li>
            {#each Object.entries(item) as [key, value]}
                {#if key!='key' && key!='name'}
                  <li class="list-group-item">
                    <div class="form-check form-switch">
                      <input class="form-check-input" type="checkbox" id="check_{item.key}_{key}" bind:checked={permisos[item.key][key]}>
                      <label class="form-check-label" for="check_{item.key}_{key}">{@html value}</label>
                    </div>
                  </li>
                {/if}

            {/each}

    {/each}   

</ul>

{#if acciones===true}
      <!-- svelte-ignore a11y-autofocus -->
      {#if cmd=='botones'}
        <div class='mt-3' in:fly={{y:50}}>
          <button class='btn btn-sm btn-primary' on:click={asignar} ><i class="bi bi-arrow-right-square me-1"></i>Asignar Grupo</button>
          <button class='btn btn-sm btn-success' on:click={guardar}><i class="bi bi-save me-1"></i>Guardar Grupo</button>
        </div>
      {:else if cmd=='asignando'}

        <div class='mt-3' in:fly={{y:50}}>
            <div class="input-group">
              
              <select bind:value={assignValue} class="form-select" disabled={assignPermisosDisabled}>
                  {#each assignPermisos as item,index}
                      <option value={index}>{item.nombre}</option>
                  {/each}
              </select>
              <button class="btn btn-success" disabled={assignPermisosDisabled} type="button" on:click={asignGroup}><i class="bi bi-arrow-right-square"></i></button>
              <button class="btn btn-danger" disabled={assignPermisosDisabled} type="button" on:click={()=>cmd='botones'}><i class="bi bi-x-square"></i></button>
            </div>
        </div>
      {:else if cmd=='guardar'}

        <div class='mt-3' in:fly={{y:50}}>

          <div class="input-group">
            <input disabled={grupoTextDisabled} type="text" class="form-control" placeholder="Nombre del Grupo" autofocus bind:value={grupoTextGuardar} bind:this={grupoTextGuardarObj}>
            <button  disabled={grupoTextDisabled} class="btn btn-success" type="button" on:click={save}><i class="bi bi-save"></i></button>
            <button disabled={grupoTextDisabled} class="btn btn-danger" type="button" on:click={()=>cmd='botones'}><i class="bi bi-x-square"></i></button>
          </div>
        </div>
        {#if grupoTextGuardarError!==false}
          <p in:fly={{y:-20}} class='text-danger mt-1 ms-1'><i class="bi bi-exclamation-octagon-fill me-1"></i>{@html grupoTextGuardarError}</p>
        {/if}
        {#if grupoTextGuardarMsj!==false}
          <p in:fly={{y:-20}} class='text-success mt-1 ms-1'><i class="bi bi-check-lg me-1"></i>{@html grupoTextGuardarMsj}</p>
        {/if}    
        
      {/if}
{/if}